import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SuiteHistoryFilter } from "./SuiteHistoryFilter";
import {
  ImageAppHistoryItem,
  SuiteApps,
  TextAppHistoryItem,
} from "../../../Helper";
import { DeleteAllHistoryModal } from "./DeleteAllHistoryModal";
import {
  GetOptionsRequest,
  useDeleteImageSuiteHistory,
  useDeleteTextSuiteHistory,
  useGetImageSuiteHistoryApps,
  useGetTextSuiteHistoryApps,
} from "../../../store/Apis/SuitesApps/SuiteHistroyApi";
import { VideoHistoryData } from "../../../Types/VideoSuite-Types";
import {
  useDeleteVideoSuiteHistory,
  useGetVideoSuiteHistory,
  useGetVideoSuiteHistoryApps,
} from "../../../store/Apis/SuitesApps/VideoSuiteHistoryApi";

export interface FilterAppItem {
  id: string;
  name: string;
}
interface SuiteHistoryNavbarApp {
  textAppItems: TextAppHistoryItem[] |null;
  imageAppItems: ImageAppHistoryItem[] |null;
  videoAppItems: VideoHistoryData[] |null;
  getTextHistoryItems: (data?: GetOptionsRequest) => void;
  getImageHistoryItems: (data?: GetOptionsRequest) => void;
  getVideoHistoryItems: (data?: GetOptionsRequest) => void;
}

export const SuiteHistoryNavbar = ({
  textAppItems,
  imageAppItems,
  videoAppItems,
  getTextHistoryItems,
  getImageHistoryItems,
  getVideoHistoryItems,
}: SuiteHistoryNavbarApp) => {
  const {
    mutate: DeleteAllTextSuiteHistory,
    isSuccess: isDeleteTextHistorySuccess,
    isPending: isDeleteTextHistoryLoading,
  } = useDeleteTextSuiteHistory();
  const {
    mutate: DeleteVideoSuiteHistory,
    isSuccess: isDeleteVideoHistorySuccess,
    isPending: isDeleteVideoHistoryLoading,
  } = useDeleteVideoSuiteHistory();
  const {
    mutate: DeleteAllImageSuiteHistory,
    isSuccess: isDeleteImageHistorySuccess,
    isPending: isDeleteImageHistoryLoading,
  } = useDeleteImageSuiteHistory();
  const { refetch: GetTextFiltrationApps, data: TextFilterApps } =
    useGetTextSuiteHistoryApps();
  const { refetch: GetImageFiltrationApps, data: ImageFilterApps } =
    useGetImageSuiteHistoryApps();

  const { refetch: GetVideoFiltrationApps, data: videoHistoryApps } =
    useGetVideoSuiteHistoryApps();
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const navigate = useNavigate();
  const [activeApp, setActiveApp] = useState("");
  const [filterApps, setFilterApps] = useState<FilterAppItem[]>([]);
  const [canShowDeleteAllHistory, setCanShowDeleteAllHistory] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");

  const SuiteHistoryNavbarApps = [
    {
      appTitle: SuiteApps.Text,
      appItemsCount: textAppItems?.length || 0,
      appRoute: "/text",
    },
    {
      appTitle: SuiteApps.Image,
      appItemsCount: imageAppItems?.length || 0,
      appRoute: "/image",
    },
    {
      appTitle: SuiteApps.Video,
      appItemsCount: videoAppItems?.length || 0,
      appRoute: "/video",
    },
  ];

  useEffect(() => {
    if (window.location.pathname.includes("history/text")) {
      GetTextFiltrationApps();
      setActiveApp(SuiteApps.Text);
      setSearchInputValue("");
    } else if (window.location.pathname.includes("history/image")) {
      GetImageFiltrationApps();
      setActiveApp(SuiteApps.Image);
      setSearchInputValue("");
    } else if (window.location.pathname.includes("history/video")) {
      GetVideoFiltrationApps();
      setActiveApp(SuiteApps.Video);
      setSearchInputValue("");
    }
  }, [window.location.pathname]);

  useEffect(() => {
    if (isDeleteTextHistorySuccess) {
      getTextHistoryItems();
      handleShowDeleteAllHistory(false);
    } else if (isDeleteImageHistorySuccess) {
      getImageHistoryItems();
      handleShowDeleteAllHistory(false);
    } else if (isDeleteVideoHistorySuccess) {
      getVideoHistoryItems();
      handleShowDeleteAllHistory(false);
    }
  }, [
    isDeleteTextHistorySuccess,
    isDeleteImageHistorySuccess,
    isDeleteVideoHistorySuccess,
  ]);

  useEffect(() => {
    if (
      isDeleteImageHistoryLoading ||
      isDeleteTextHistoryLoading ||
      isDeleteImageHistoryLoading
    ) {
      setIsDeleteLoading(true);
    } else {
      setIsDeleteLoading(false);
    }
  }, [
    isDeleteImageHistoryLoading,
    isDeleteTextHistoryLoading,
    isDeleteImageHistoryLoading,
  ]);

  useEffect(() => { 
    if (activeApp === SuiteApps.Image) {
      setFilterApps(ImageFilterApps);
    } else if (activeApp === SuiteApps.Text) {
      setFilterApps(TextFilterApps);
    } else if (activeApp === SuiteApps.Video) {
      setFilterApps(videoHistoryApps);
    }
  }, [TextFilterApps, ImageFilterApps, videoHistoryApps,activeApp]);

  const handleNavigateToHistoryApp = (route: string) => {
    navigate(`/suites/history${route}`);
    setFilterApps(videoHistoryApps);
  };

  const handleShowDeleteAllHistory = (canShow: boolean) => {
    setCanShowDeleteAllHistory(canShow);
  };

  const handleDeleteAllHistory = () => {
    switch (activeApp) {
      case SuiteApps.Text:
        if (textAppItems&&textAppItems?.length > 0) DeleteAllTextSuiteHistory();
        break;
      case SuiteApps.Image:
        if (imageAppItems&&imageAppItems?.length > 0) DeleteAllImageSuiteHistory();
        break;
      case SuiteApps.Video:
        if (videoAppItems&&videoAppItems?.length > 0) DeleteVideoSuiteHistory();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Box className="suite-history-navbar">
        <Box className="suite-history-navbar-apps">
          {SuiteHistoryNavbarApps.map((app, index) => (
            <Box
              key={index}
              className={`suite-history-navbar-app ${
                activeApp === app.appTitle ? "active" : ""
              }`}
              onClick={() => handleNavigateToHistoryApp(app.appRoute)}
            >
              <Typography className="app-title">{app.appTitle}</Typography>
              <Typography className="app-items-count">{`(${app.appItemsCount})`}</Typography>
            </Box>
          ))}
        </Box>
        <Box className="suite-history-navbar-actions">
          <SuiteHistoryFilter
            handleOpenDeleteModal={handleShowDeleteAllHistory}
            filterApps={filterApps}
            getTextHistoryItems={getTextHistoryItems}
            getImageHistoryItems={getImageHistoryItems}
            getVideoHistoryItems={getVideoHistoryItems}
            activeApp={activeApp}
            searchInputValue={searchInputValue}
            setSearchInputValue={setSearchInputValue}
          />
        </Box>
      </Box>
      {canShowDeleteAllHistory && (
        <DeleteAllHistoryModal
          canShow={canShowDeleteAllHistory}
          handleClose={() => handleShowDeleteAllHistory(false)}
          handleDeleteAllHistory={handleDeleteAllHistory}
          isDeleteLoading={isDeleteLoading}
          message="Are you sure to clear “All history”?"
        />
      )}
    </>
  );
};
